/**
 * 创建人：张丽莉
 * 时间：2019-12-19
 * 描述：对日期格式进行格式化(解决ie11日期为字符串类型时，默认date管道不能解析日期的问题)
 * 更新记录: 
 */
import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

@Pipe({
  name: 'formatDate'
})
export class FormatDatePipe implements PipeTransform {
  //获取当前dom节点
  constructor(){}
  /**
   * 格式化时间字符串
   * @param value 时间字符串
   * @param args 要格式化成的格式  => YYYY-MM-DD HH:mm:ss
   */
  transform(value: any , args: any): any {
    //date: 'yyyy-MM-dd HH:mm:ss' (angular自带的默认的日期的格式 =>ie11时 若value为字符串 识别不了 value需要格式为日期格式) => 所以此方法暂时不用
    // YYYY-MM-DD HH:mm:ss
    if(value) {
      return moment(value).format(args);
    }
  }
} 
